import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { FiAIAssistanceService } from '@fi-shared/fi-ai-assistance/fi-ai-assistance.service';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { TextEditorInsertMediaService } from '@fi-shared/text-editor/text-editor-insert-media.service';
import { FiAIAssistanceHelperService } from '@fi-shared/fi-ai-assistance/fi-ai-assistance-helper.service';
import { takeUntil } from 'rxjs/operators';
import { eventFindInPath, findClosest, findClosestElement, isDefined } from '@fi-shared/utils';
import { Subject } from 'rxjs';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';

// todo: remove
@Component({
    selector: 'fi-ai-assistance-panel-handler',
    templateUrl: './fi-ai-assistance-panel-handler.component.html',
    styleUrl: './fi-ai-assistance-panel-handler.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-ai-assistance-panel-handler' },
    standalone: false,
})
export class FiAiAssistancePanelHandlerComponent implements OnInit, OnDestroy {
    @Input() editableElement: HTMLElement;
    @HostBinding('style.visibility') get panelVisibilityStyle(): string {
        return this.isPanelShown ? 'visible' : 'hidden';
    }
    private isPanelShown: boolean = false;
    aiAssistanceMessage: string = ''; // 'how to hard boil eggs?' // todo for tests

    constructor(
        private fiAIAssistanceService: FiAIAssistanceService,
        public fiAIAssistanceHelperService: FiAIAssistanceHelperService,
        private textEditorHistoryService: TextEditorHistoryService,
        private textEditorInsertMediaService: TextEditorInsertMediaService,
        private fiBrowserEventsService: FiBrowserEventsService,
        private cdr: ChangeDetectorRef,
        private elementRef: ElementRef<HTMLElement>,
    ) {}

    ngOnInit(): void {
        // this.fiAIAssistanceHelperService.showAIAssistanceInput$.subscribe(() => {
        //     const element = this.textEditorHistoryService.getElement();
        //     const editorElement = findClosest(element, '[contenteditable]');
        //     if (this.editableElement === editorElement) {
        //         this.fiAIAssistanceService.getRecentAIRequests().then(recentAIRequests => {
        //             this.isPanelShown = true;
        //             this.cdr.markForCheck();
        //         });
        //     }
        //
        // });

        this.fiBrowserEventsService
            .getDocumentEventSubject$('click')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((event) => {
                const target: HTMLElement = event.target as HTMLElement;
                // ignore click on panel
                if (findClosestElement(target, this.elementRef.nativeElement) || this.isIgnored(target)) {
                    return;
                }
                this.isPanelShown = false;
                //this.fiAiAssistanceHelperService.hideAIAssistanceInput();
            });

        // this.fiBrowserEventsService.getDocumentEventSubject$('keydown')
        //     .pipe(takeUntil(this.ngOnDestroy$))
        //     .subscribe((event: KeyboardEvent) => {
        //         if (event.key === 'Enter') {
        //             event.preventDefault();
        //             event.stopPropagation();
        //             if (!!this.aiAssistanceMessage?.trim().length) {
        //                 this.sendAIAssistanceMessage();
        //             }
        //         }
        //     });
    }

    /*
    sendAIAssistanceMessage() {
        this.fiAIAssistanceService.sendMessageToAI(this.aiAssistanceMessage).then(aiAssistanceResponse => {
            const el = this.textEditorHistoryService.getElement();
            const selection = document.getSelection();
            const range = this.textEditorInsertMediaService.getRangeForMediaInsert(el, selection);
            const aiResponseElement = this.fiAIAssistanceHelperService.getAIResponseElement(aiAssistanceResponse);
            range.insertNode(aiResponseElement);
            range.collapse(false);
            this.fiAIAssistanceHelperService.saveRecentAIRequest(this.aiAssistanceMessage);
            this.aiAssistanceMessage = '';
            this.isPanelShown = false;
        });
    }
     */

    private isIgnored(target: HTMLElement): boolean {
        const ignoreClasses = []; // todo ?
        return ignoreClasses.some((ignoreClass) => !!eventFindInPath({ target }, ignoreClass));
    }

    onClick($event: MouseEvent) {
        // don't set focus to editable element on fi-ai-assistance-panel-handler click
        $event.stopPropagation();
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
